var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_core.js
// module id = 10
// module chunks = 0